import React from "react";
import { Route, Redirect } from "react-router-dom";

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expiry = payload.exp;
    const now = Math.floor(Date.now() / 1000);
    return now > expiry;
  } catch (error) {
    return true;
  }
};

const isAuthenticated = () => {
  const token = localStorage.getItem("user");

  if (!token) return false;
  return !isTokenExpired(token);
};

const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to="/page-login" />
        )
      }
    />
  );
};

export default ProtectedRoute;
